module.exports = __webpack_public_path__ + "static/media/caret-down.a82e0187.svg";